import React from 'react'
import ReturnDetails from '../../../OrderDetails/ReturnDetails/ReturnDetails'

const DisplayReturnDetails = ({ moduleData }) => {
  const {
    Link,
    isDesktop,
    creditStatus,
    returnReasonUtils,
    returnDetailsData,
    returnRequestStatus,
    setReturnDetailsData,
    setDisplayReturnDetails,
  } = { ...moduleData }
  return (
    <ReturnDetails
      Link={Link}
      isDesktop={isDesktop}
      creditStatus={creditStatus}
      returnReasonUtils={returnReasonUtils}
      returnDetailsData={returnDetailsData}
      returnRequestStatus={returnRequestStatus}
      setReturnDetailsData={setReturnDetailsData}
      setDisplayReturnDetails={setDisplayReturnDetails}
    />
  )
}

export default DisplayReturnDetails
